import { PlanVo } from "@/api";
import { Button } from "@/component/Button";
import classNames from "classnames";
import { formatNumberWithCommas } from "../../../util/formatNumber";
import { isFreePlan } from "../Pricing.helpers";
import recommendButtonBg from "./assets/recommend-plan-button.webp";

interface PlanButtonProps {
  className?: string;
  plan: PlanVo;
  onClick?: () => void;
  isCurrentPlan?: boolean;
  subscriptionBonus?: number;
}

export function PlanButton({
  className = "",
  plan,
  onClick,
  isCurrentPlan = false,
  subscriptionBonus = 0,
}: PlanButtonProps) {
  const isFree = isFreePlan(plan);

  if (isCurrentPlan) {
    const clsName = isFree
      ? "text-text-primary bg-background-elevated"
      : "text-text-primary bg-primary/10";

    return (
      <p
        className={classNames(
          className,
          "flex items-center justify-center text-sm font-medium gap-1 h-12 rounded-full",
          clsName,
        )}
      >
        <span>Your current plan</span>
      </p>
    );
  }

  if (isFree) {
    return (
      <Button
        type="default"
        className={classNames(
          "rounded-full bg-background-elevated text-text-primary",
          className,
        )}
        onClick={onClick}
      >
        Try for free
      </Button>
    );
  }

  return (
    <Button
      type="primary"
      onClick={onClick}
      className={classNames(`rounded-full !font-bold relative`, className)}
      style={{
        background: plan.recommend ? `url(${recommendButtonBg.src})` : "",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {subscriptionBonus > 0 && (
        <div className="absolute right-[-6px] top-[-11px] z-10 inline-flex items-center justify-center gap-2.5 rounded-bl-md rounded-tl-md rounded-tr-md px-2 py-0.5 bg-[#d24244] text-white">
          <div className="font-poppins justify-start text-xs font-medium">
            {formatNumberWithCommas(subscriptionBonus)} one-time bonus
          </div>
          <div className="absolute right-0 top-full h-0 w-0 border-r-[6px] border-t-[6px] border-r-transparent border-t-[#C30103]"></div>
        </div>
      )}
      {`Get ${plan.memberShipName || "Plan"}`}
    </Button>
  );
}
